import { mediaLifeSpanMVConfig } from '@/lib/analytics/charts/youtube/mediaViewer/mediaLifeSpan';
import { mediaViewerCommentsConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerComments';
import { mediaViewerLikesConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerLikes';
import { mediaViewerSharesConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerShares';
import { mediaViewerVideoDuration } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerVideoDuration';
import { mediaViewerVideoViewsAvgTimeWatchedConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerVideoViewsAvgTimeWatched';
import { mediaViewerVideoViewsTotalTimeConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerVideoViewsTotalTime';
import { mediaViewerViewsConfig } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerViews';
import { mediaViewerViewsRate } from '@/lib/analytics/kpis/youtube/mvConfig/mediaViewerViewsRate';
import { POST, YT_POST_TYPES } from '@/lib/posts/postTypes';

const VIDEO_CONFIG = [
    mediaViewerViewsConfig,
    mediaViewerLikesConfig,
    mediaViewerVideoViewsTotalTimeConfig,
    mediaViewerVideoViewsAvgTimeWatchedConfig,
    mediaViewerCommentsConfig,
    mediaViewerSharesConfig,
    mediaViewerViewsRate,
    mediaViewerVideoDuration,
    mediaLifeSpanMVConfig
];

export const MediaViewerStatsYoutube = {
    [POST]: {
        [YT_POST_TYPES.TYPE_VIDEO]: VIDEO_CONFIG,
        [YT_POST_TYPES.TYPE_SHORT]: VIDEO_CONFIG
    }
};
